<template>
  <div class="school-view-page">
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/school' }">
        <app-i18n code="entities.school.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.school.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>-->

    <!-- Header -->
    <div class="school-view-page__header">
      <!-- Back button -->
      <app-back-button
        i18nCode="common.back.default"
      />
      <!-- Button edit -->
      <div class="school-view-page__header__edit">
        <router-link
          :to="{
            name: 'schoolEdit',
            params: {
              id
            } 
          }"
        >
          <el-button type="primary">
            <app-i18n code="entities.school.edit.title" />
          </el-button>
        </router-link>
      </div>
    </div>

    <!-- Back Button -->
    <!-- <app-back-button route-name="school" :i18nCode="`entities.school.label`" />- -->

    <div class="school-view-page__card" v-if="record">
      <span class="school-view-page__card__name" v-text="record.name"></span>
      <i class="icon-location school-view-page__card__icon"></i>
      <span class="school-view-page__card__location" v-text="record.location.name"></span>
    </div>

    <div class="app-content-page">
      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>
      <el-table
        ref="table"
        row-key="id"
        v-loading="loading"
        v-if="record"
        :data="record.teams"
        @sort-change="doChangeSort"
        @row-click="onRowClick"
      >
        <!-- Team name -->
        <el-table-column :resizable="false" :label="i18n('entities.school.view.fields.franchise')" min-width="120">
          <template slot-scope="scope">
            <span v-text="scope.row.name"></span>
          </template>
        </el-table-column>

        <!-- Categories -->
        <el-table-column :resizable="false" :label="i18n('entities.school.view.fields.category')" min-width="100">
          <template slot-scope="scope">
            <span v-text="get(scope.row, 'subprogram.name', i18n('common.none'))"></span>
          </template>
        </el-table-column>

        <!-- Location -->
        <el-table-column :resizable="false" :label="i18n('entities.school.view.fields.location')" min-width="180">
          <span v-text="record.location.name"></span>
        </el-table-column>

        <!-- Managers -->
        <el-table-column :resizable="false" :label="i18n('entities.school.view.fields.manager')" min-width="140">
          <app-i18n v-if="!record.coaches || !record.coaches.length" code="common.none" />
          <span v-else-if="record.coaches.length === 1" v-text="record.coaches[0].email" />
          <el-tooltip
            v-else-if="record.coaches.length > 1"
            effect="dark"
            :content="record.coaches.map(coach => coach.email).join('\n')"
            placement="bottom"
          >
            <app-i18n code="entities.coach.list.multipleCoaches" />
          </el-tooltip>
        </el-table-column>

        <!-- <el-table-column align="center" min-width="40">
          <template slot-scope="scope">
            <div class="table-actions">
              <router-link
                :to="{ name: 'SubprogramNbaSchoolTeamView',
                params: { programId: scope.row.program, subprogramId: scope.row.subprogram, teamId: scope.row.id } }"
                v-if="hasPermissionToEdit">
                <el-button icon="icon-pen" circle />
              </router-link>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { SchoolModel } from '@modules/school/school-model';
import { SchoolPermissions } from '@modules/school/school-permissions';
import { i18n } from '@shared/i18n';
import {get} from 'lodash';
const { fields } = SchoolModel;

export default {
  name: 'app-school-view-page',

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'school/view/record',
      loading: 'school/view/loading',
      currentUser: 'auth/currentUser',
    }),
    fields() {
      return fields;
    },
    hasPermissionToEdit() {
      return new SchoolPermissions(this.currentUser).edit;
    },
  },

  async created() {
    await this.doFind({ id: this.id });
  },

  methods: {
    ...mapActions({
      doFind: 'school/view/doFind',
      doChangeSort: 'school/list/doChangeSort',
    }),

    presenter(record, fieldName) {
      return SchoolModel.presenter(record, fieldName);
    },

    i18n(code) {
      return i18n(code);
    },

    get(a,b,c) {
      return get(a,b,c);
    },

    onRowClick(row, column) {
      if (!('label' in column)) return;
      this.$router.push({
        name: 'SubprogramNbaSchoolTeamView',
        params: {
          programId: row.program.id,
          subprogramId: row.subprogram.id,
          teamId: row.id,
          tabName: 'summary'
        }, 
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.school-view-page {
  &__header {
    display: grid;
    grid-template-areas: 'back edit';
    &__edit {
      justify-self: flex-end;
    }
  }
  &__card {
    display: grid;
    grid-template-areas: 'name name' 'icon location';
    grid-template-columns: 24px;
    grid-template-rows: 32px;
    padding: 24px 32px;
    margin-top: 22px;
    box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
    background-color: #ffffff;
    &__name {
      grid-area: name;
      color: #5d5d5d;
      font-size: 18px;
      font-weight: bold;
    }
    &__icon {
      grid-area: icon;
      color: #999999;
    }
    &__location {
      grid-area: location;
      color: #999999;
    }
  }
}
</style>
<style>
.school-view-page .el-table:not(.el-table--simple) td:last-of-type .cell {
  padding: 0 30px;
}
</style>